import { render, staticRenderFns } from "./MaydayWebUserFavorites.vue?vue&type=template&id=67d74665&scoped=true&"
import script from "./MaydayWebUserFavorites.vue?vue&type=script&lang=js&"
export * from "./MaydayWebUserFavorites.vue?vue&type=script&lang=js&"
import style0 from "./MaydayWebUserFavorites.vue?vue&type=style&index=0&id=67d74665&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d74665",
  null
  
)

export default component.exports